import React, { useEffect, useState } from "react";
import "./styles.scss";
import {
  AdminNewsCard,
  Button,
  CategoryCard,
  DropBox,
  FormHeader,
  InputBox,
  Pagination,
} from "../../components";
import { withRouter } from "react-router-dom/cjs/react-router-dom.min";
import { CreateNewNews } from "../CreateNewItem";
import { CheckValidity } from "../../utils/formValidity";
import { getAllNews, getNewsByPage } from "./service/news.service";
import Scrollbars from "react-custom-scrollbars-2";
import { useDispatch } from "react-redux";
import {
  openAddUpdateNewsModal,
  openNewsViewModal,
  setNews,
} from "./redux/actions";
import { getLanguage } from "../../utils";

const lan = getLanguage();

const News = () => {
  const [viewPointWidth, setViewPointWidth] = useState(0);
  const [viewPointHeight, setViewPointHeight] = useState(0);
  const [pageNo, setPageNo] = useState("");
  const [pageSize, setPageSize] = useState(5);
  const [pageCount, setPageCount] = useState(10);
  const [isLoading, setIsLoading] = useState(false);
  const [formData, setFormData] = useState({
    language: {
      key: "language",
      label: "",
      size: "sm",
      placeholder: "Sinhala",
      mainLayerStyles: " flex-column " + " align-content-center ",
      iconName: "",
      isRequired: false,
      loading: false,
      elementConfig: {
        options: [],
      },
      touched: false,
      validation: {
        required: true,
      },
      isValid: false,
      invalidReason: "",
      value: "",
    },
    TitleSI: {
      key: "TitleSI",
      label: "",
      size: "lg",
      isShowRequired: false,
      elementConfig: {
        type: "text",
        placeholder: "Search by news title",
      },
      touched: false,
      validation: {
        required: true,
      },
      isValid: false,
      invalidReason: "",
      value: "",
      mainLayerStyles: "",
    },
    category: {
      key: "category",
      label: "",
      size: "lg",
      placeholder: "select category",
      mainLayerStyles: " flex-column " + " align-content-center ",
      iconName: "",
      isRequired: false,
      loading: false,
      elementConfig: {
        options: [],
      },
      touched: false,
      validation: {
        required: true,
      },
      isValid: false,
      invalidReason: "",
      value: "",
    },
  });

  const [newsList, setNewsList] = useState([]);

  const dispatch = useDispatch();

  // scrollbars start
  useEffect(() => {
    updateWindowDimensions();
    window.addEventListener("resize", updateWindowDimensions);
    window.addEventListener("scroll", handleOnScroll);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    return () => {
      window.removeEventListener("scroll", handleOnScroll);
      window.removeEventListener("resize", updateWindowDimensions);
    };
  }, []);

  const updateWindowDimensions = () => {
    setViewPointWidth(window.innerWidth);
    setViewPointHeight(window.innerHeight);
  };

  const handleOnScroll = () => {
    let scrollTop =
      (document.documentElement && document.documentElement.scrollTop) ||
      document.body.scrollTop;
    let scrollHeight =
      (document.documentElement && document.documentElement.scrollHeight) ||
      document.body.scrollHeight;
    let clientHeight =
      document.documentElement.clientHeight || window.innerHeight;
  };
  // scrollbars end

  const fetchData = async () => {
    try {
      const response = await getNewsByPage(lan, 10, 1);
      console.log("Get news In page: ", response);

      if (response.data) {
        setNewsList(response?.data?.news);
        setPageCount(response?.data?.count);
        setPageNo(1);
      } else {
        setNewsList([]);
        console.log("Data Not Found");
      }
    } catch (error) {
      console.log("Error fetching Category", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const onChangePage = async (pageNumber, size) => {
    console.log("onChangePage", pageNumber, size);
    try {
      if (pageNumber !== pageNo || size !== pageSize) {
        let response = await getNewsByPage(lan, size, pageNumber);
        console.log("response next::", response);
        if (response?.data?.news?.length > 0) {
          setNewsList(response?.data?.news);
          setPageNo(pageNumber);
          setPageSize(size);
          setPageCount(response?.data?.count);
          window.scrollTo(0, 0);
        }
      }
    } catch (error) {
      console.log("Error fetching news by page", error);
      setIsLoading(false);
    }
  };

  const handleChange = async (event, inputIdentity) => {
    const updateNewsForm = {
      ...formData,
    };

    updateNewsForm[inputIdentity].value = event;
    let validityRes = await CheckValidity(
      inputIdentity,
      updateNewsForm[inputIdentity].value,
      updateNewsForm[inputIdentity].validation
    );

    if (validityRes) {
      updateNewsForm[inputIdentity].isValid = validityRes.isValid;
      updateNewsForm[inputIdentity].invalidReason = validityRes.reason;
      updateNewsForm[inputIdentity].value = event;
      updateNewsForm[inputIdentity].touched = true;
      console.log("required_validation", validityRes);

      let formIsValid = false;
      for (let inputIdentifier in updateNewsForm) {
        formIsValid = updateNewsForm[inputIdentifier].valid && formIsValid;
      }
      console.log("formIsValid", formIsValid);
      setFormData(updateNewsForm);
    }
  };

  const updateNewsForm = { ...formData };

  // scrollbars start
  useEffect(() => {
    updateWindowDimensions();
    window.addEventListener("resize", updateWindowDimensions);
    window.addEventListener("scroll", handleOnScroll);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    return () => {
      window.removeEventListener("scroll", handleOnScroll);
      window.removeEventListener("resize", updateWindowDimensions);
    };
  }, []);

  // scrollbars end

  return (
    <>
      <div className={"hne-news-wrapper"}>
        <div className={"col-8 news-body-wrapper"}>
          <div className={"d-flex flex-row justify-content-between"}>
            <FormHeader
              data={{
                formHeader: "News",
                size: "md-md",
              }}
            />
            <div>
              <DropBox
                data={updateNewsForm.language}
                onChange={(e) => {
                  const updateForm = { ...formData };
                  updateForm["language"].value = e;
                  setFormData(updateForm);
                  // dispatch(setCategoryDetails(e));
                }}
              />
            </div>
          </div>

          <div className={"hne-action-wrapper"}>
            <div className={"hne-aw-input-wrapper"}>
              <div style={{ minWidth: "228px" }}>
                <InputBox
                  data={updateNewsForm.TitleSI}
                  onChange={async (e) => {
                    e.preventDefault();
                    await handleChange(
                      e.target.value,
                      updateNewsForm.TitleSI.key
                    );
                  }}
                />
              </div>
              <div style={{ minWidth: "205px" }}>
                <DropBox
                  data={updateNewsForm.category}
                  onChange={(e) => {
                    const updateForm = { ...formData };
                    updateForm["category"].value = e;
                    setFormData(updateForm);
                    // dispatch(setCategoryDetails(e));
                  }}
                />
              </div>
            </div>
            <div className={"hne-aw-action-wrapper"}>
              <Button
                data={{
                  btnName: "REFRESH",
                  buttonType: "border",
                  buttonSize: "sm x",
                  isLoading: false,
                }}
                onClick={async (e) => {
                  await fetchData(e);
                }}
              />
              <Button
                data={{
                  btnName: "SEARCH",
                  buttonType: "primary",
                  buttonSize: "sm x",
                  isLoading: false,
                }}
                // onClick={async (e) => {
                //   e.preventDefault();
                //   await onClickSave(e);
                // }}
              />
            </div>
          </div>
          <div className={"hne-new-body-wrapper pr-3"}>
            <Scrollbars
              onScroll={handleOnScroll}
              renderView={(props) => (
                <div
                  {...props}
                  style={{ ...props.style, overflowX: "hidden" }}
                />
              )}
              style={{ height: viewPointHeight - 330 }}
            >
              {newsList?.length > 0 &&
                newsList.map((news) => (
                  <AdminNewsCard
                    item={news}
                    isUpdate={news?.updates?.length > 0}
                    onClickEdit={() => {
                      dispatch(setNews(news));
                    }}
                    onClickAdd={() => {
                      dispatch(setNews(news));
                      dispatch(openAddUpdateNewsModal());
                    }}
                    onClickView={() => {
                      dispatch(setNews(news));
                      dispatch(openNewsViewModal());
                    }}
                  />
                ))}
            </Scrollbars>
            <div
              className={
                "d-flex flex-column justify-content-center align-items-center mt-3"
              }
              style={{
                marginBottom: "20px",
                borderTop: "1px solid #e0e0e0",
                paddingTop: "20px",
              }}
            >
              <Pagination
                data={{
                  paginationCount: pageCount,
                  pageNo: pageNo,
                  pageSize: pageSize,
                }}
                onChange={onChangePage}
              />
            </div>
            {/* <AdminNewsCard />
            <AdminNewsCard />
            <AdminNewsCard /> */}
          </div>
        </div>

        {/*right side*/}
        <div className={"col-4 news-right-side-wrapper"}>
          <CreateNewNews />
        </div>
      </div>
    </>
  );
};
export default withRouter(News);
